module.exports = __webpack_public_path__ + "static/media/icon.2cd62bdc.png";